export function paginateList(list, pageNum, perPage) {

    let newArr = []
    list.map((item, index) => {
        if(pageNum === 1){
            if(index < perPage){
                newArr.push(item)
            }
        } else if(index >= perPage*(pageNum-1) && index < pageNum*perPage) {
            newArr.push(item)
        }
    })

    return newArr
}

export function paginationTotal(length,perPage) {
    console.log("Length is ", length)
    return length % perPage === 0 ? parseInt(length / perPage) : parseInt((length / perPage) + 1)
}